export {mzData} from './mzData';



// WEBPACK FOOTER //
// ./node_modules/mzmjs/src/index.js